import React, { useEffect, useState } from "react";
import { Toaster, toast } from "react-hot-toast"; // Import the toast function
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route, HashRouter } from "react-router-dom";
// import Capture from "./Components/Capture";
import Gallery from "./Components/Gallery";
import ButtonBar from "./Components/ButtonBar";
import SignSdk from "./Components/SignSdk";
import axios from "axios";


// import Home from "./Components/Home";
import './App.css'
import Video from "./Video";

function App() {
  const [dataStatus, setDataStatus] = useState(null); // State to store data status
  const [loading, setLoading] = useState(true); // State to track if token check is in progress
  const [showTokenModal, setShowTokenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");


  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("t");

    if (!token) {
      // toast.error("Token not provided");
      setDataStatus(0);
      setLoading(false);
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("x-api-key", "wvKOfaU6fe7akPsnEcjKB8ghlMYT64Pv8MGbTvVk");
    myHeaders.append("Content-Type", "application/json");

    const rawRequestBody = JSON.stringify({ token });

    fetch(
      " https://5mem4uf8ai.execute-api.ap-south-1.amazonaws.com/default/Sign_Web_SDK_PROD_TOKEN_VERIFY",
      {
        method: "POST",
        headers: myHeaders,
        body: rawRequestBody,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 1) {
          setDataStatus(data.status);
          setLoading(false);
        } else {
          setLoading(false);
          console.log("Token expired or invalid (status 0)");
          setModalMessage("Session timed out. Please login again.");
          setShowTokenModal(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setModalMessage("Session timed out. Please login again.");
        setShowTokenModal(true);
        setDataStatus(0);
        setLoading(false);
      });
  }, []);

  const handleModalConfirm = () => {
    setShowTokenModal(false);
    window.parent.postMessage({ status: 0, remark: 'Session TimeOut' }, "*");
    // Optional: redirect to login if needed
    // window.location.href = "http://localhost:5173"; 
  };


  return (
    <HashRouter>
      {/* Wrap the entire application with ToastProvider */}
      <Toaster
        toastOptions={{
          className: "",
          style: {
            border: "1px solid #713200",
            padding: "16px",
            // color: "#FF0000",
          },
        }}
      />

      {/* <TokenExpiryModal 
        show={showTokenModal} 
        message={modalMessage} 
        onConfirm={handleModalConfirm} 
      /> */}

      {/* Conditionally render the routes based on dataStatus */}
      <Routes>
        <>
          <Route path="/" element={<SignSdk />} />
          <Route path="/buttons" element={<ButtonBar />} />
          {/* <Route path="/Capture" element={<Capture />} /> */}
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/SignSdk" element={<SignSdk />} />
          <Route path="/Video" element={<Video />} />
        </>
      </Routes>
    </HashRouter>
  );
}

export default App;
